import moment from 'moment';

import getExternalTooltipDateRange from './getExternalTooltipDateRange';

const uppercaseFirstLetter = str => `${str[0].toUpperCase()}${str.slice(1)}`;

const getExternalTooltipDate = (dateFrom, dateTo) =>
  moment(dateTo).diff(moment(dateFrom), 'days') > 1
    ? getExternalTooltipDateRange(dateFrom, dateTo)
    : uppercaseFirstLetter(moment(dateFrom).format('ddd. DD.MM.YYYY'));

export default getExternalTooltipDate;
